import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { GuidedTourService } from '../../services/tour/guided-tour.service';

@Component({
  selector: 'app-tour-prompt',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tour-prompt.component.html',
  styleUrl: './tour-prompt.component.scss',
})
export class TourPromptComponent {
  readonly tourService = inject(GuidedTourService);

  startTour(): void {
    const tour = this.tourService.promptTour();
    if (tour) {
      this.tourService.startTour(tour);
    }
  }

  dismiss(): void {
    this.tourService.dismissPrompt();
  }
}
